//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

  const readableNumberImpl = function(val, includeSign) {
        // TODO: Make this a pure Angular directive, lose the dependency on the
        // TODO: global CURALATE object.
    const baseReadableNumber = CURALATE.misc.renderToReadableNumber(null, val);
    const sign = (includeSign && val > 0) ? '+' : ''; // the renderToReadableNumber call already adds a '-' sign
    return sign + baseReadableNumber;
  };

    // These are the currency symbols from Google Analytics. Automated reporting also has a similar list.
  const getRevenueSymbolFromFormat = function(currencyFormat) {
    let symbol;
    switch (currencyFormat) {
      case 'AED':
        symbol = 'AED';
        break;
      case 'ARS':
        symbol = 'ARS';
        break;
      case 'AUD':
        symbol = 'A$';
        break;
      case 'BGN':
        symbol = 'BGN';
        break;
      case 'BOB':
        symbol = 'BOB';
        break;
      case 'BRL':
        symbol = 'R$';
        break;
      case 'CAD':
        symbol = 'CA$';
        break;
      case 'CHF':
        symbol = 'CHF';
        break;
      case 'CLP':
        symbol = 'CLP';
        break;
      case 'CNY':
        symbol = 'CN¥';
        break;
      case 'COP':
        symbol = 'COP';
        break;
      case 'CZK':
        symbol = 'CZK';
        break;
      case 'DKK':
        symbol = 'DKK';
        break;
      case 'EGP':
        symbol = 'EGP';
        break;
      case 'EUR':
        symbol = '€';
        break;
      case 'FRF':
        symbol = 'FRF';
        break;
      case 'GBP':
        symbol = '£';
        break;
      case 'HKD':
        symbol = 'HK$';
        break;
      case 'HRK':
        symbol = 'HRK';
        break;
      case 'HUF':
        symbol = 'HUF';
        break;
      case 'IDR':
        symbol = 'IDR';
        break;
      case 'ILS':
        symbol = '₪';
        break;
      case 'INR':
        symbol = '₹';
        break;
      case 'JPY':
        symbol = '¥';
        break;
      case 'KRW':
        symbol = '₩';
        break;
      case 'LTL':
        symbol = 'LTL';
        break;
      case 'MAD':
        symbol = 'MAD';
        break;
      case 'MXN':
        symbol = 'MX$';
        break;
      case 'MYR':
        symbol = 'MYR';
        break;
      case 'NOK':
        symbol = 'NOK';
        break;
      case 'NZD':
        symbol = 'NZ$';
        break;
      case 'PEN':
        symbol = 'PEN';
        break;
      case 'PHP':
        symbol = 'PHP';
        break;
      case 'PKR':
        symbol = 'PKR';
        break;
      case 'PLN':
        symbol = 'PLN';
        break;
      case 'RON':
        symbol = 'RON';
        break;
      case 'RUB':
        symbol = 'RUB';
        break;
      case 'RSD':
        symbol = 'RSD';
        break;
      case 'SAR':
        symbol = 'SAR';
        break;
      case 'SEK':
        symbol = 'SEK';
        break;
      case 'SGD':
        symbol = 'SGD';
        break;
      case 'THB':
        symbol = 'THB';
        break;
      case 'TRY':
        symbol = 'TRY';
        break;
      case 'TWD':
        symbol = 'TW$';
        break;
      case 'UAH':
        symbol = 'UAH';
        break;
      case 'USD':
        symbol = '$';
        break;
      case 'VEF':
        symbol = 'VEF';
        break;
      case 'VND':
        symbol = '₫';
        break;
      case 'ZAR':
        symbol = 'R';
        break;
      default:
        symbol = '$';
        break;
    }
    return symbol;
  };

  curalate.filter('readableNumber',
        () => readableNumberImpl,
    );

  curalate.filter('optionalReadableNumber',
        () => function(val, includeSign) {
          if (_.isUndefined(val) || _.isNaN(val)) {
            return '--';
          }
          return readableNumberImpl(val, includeSign);
        },
    );

  curalate.filter('readablePrice',
        () => function(val, hideDecimal, currencyFormat) {
          if (!_.isNumber(val)) {
            return val;
          }

          const shouldHideDecimal = _.isUndefined(hideDecimal) ? false : hideDecimal;
          const currencySymbol = getRevenueSymbolFromFormat(currencyFormat);

          const valNumber = parseFloat(val);
          const valString = val.toString();

          const renderDecimalPart = valNumber < 10000;
          const valStringParts = valString.split('.');

          const wholePart = CURALATE.misc.renderToReadableNumber(null, Number(valStringParts[0]) || 0);

          if (renderDecimalPart && !shouldHideDecimal) {
            let decimalPart = (valStringParts[1] || '00').substring(0, 3);

            if (decimalPart.length === 1) {
              decimalPart += '0';
            } else if (decimalPart.length > 2) {
              decimalPart = Math.floor(parseFloat(`0.${decimalPart}`) * 100.0).toString();
              if (decimalPart.length === 1) {
                decimalPart += '0';
              }
            } else if (decimalPart.length < 2) {
              decimalPart = `0${decimalPart}`;
            }

            return `${currencySymbol}${wholePart}.${decimalPart}`;
          }
          return `${currencySymbol}${wholePart}`;
        },
    );


  curalate.filter('readableBigPrice',
        () => function(val, currencyFormat) {
          if (!_.isNumber(val)) {
            return val;
          }

          const currencySymbol = getRevenueSymbolFromFormat(currencyFormat);
          const readableNumber = readableNumberImpl(val);

          return `${currencySymbol}${readableNumber}`;
        },
    );

  curalate.filter('isNumber',
        () => function(val) {
          return _(val).isNumber();
        },
    );

    // This was created to provide accurate rounding for floating point numbers
    // For some reason (val * 100).toFixed(numDecimals) would incorrectly round sometimes (try `0.595.toFixed(2)`)
    // However, this problem doesn't occur when numbers are expressed in scientific notation
  function accurateRound(val, numDecimals) {
    return Number(`${Math.round(`${val}e${2 + numDecimals}`)}e-${numDecimals}`);
  }

  const readablePercentImpl = function(val, includePercentSymbol, includeChange) {
    if (!_.isNumber(val)) {
      return val;
    }

        // Accurately round to 2 decimal places
    let rounded = accurateRound(val, 2);

    const percentSymbolOpt = includePercentSymbol ? '%' : '';

    let changeSymbolOpt;
    if (includeChange) {
      if (rounded < 0) {
        changeSymbolOpt = '\u25BE '; // UTF-8 code for ▼
      } else {
        changeSymbolOpt = '\u25B2 '; // UTF-8 code for ▲
      }
      rounded = Math.abs(rounded);
    } else {
      changeSymbolOpt = '';
    }

    return `${changeSymbolOpt}${rounded}${percentSymbolOpt}`;
  };

  const readableScalerImpl = function(val) {
    if (!_.isNumber(val)) {
      return val;
    }

        // Accurately round to 2 decimal places
    const rounded = val.toFixed(2);

    return `${rounded}x`;
  };

  curalate.filter('readablePercent',
        () => readablePercentImpl,
    );

  curalate.filter('optionalReadablePercent',
        () => function(val, includePercentSymbol) {
          if (_.isUndefined(val) || _.isNaN(val)) {
            return '--';
          }
          return readablePercentImpl(val, includePercentSymbol);
        },
    );

  curalate.filter('optionalReadableScaler',
        () => function(val) {
          if (_.isUndefined(val) || _.isNaN(val)) {
            return '--';
          }
          return readableScalerImpl(val);
        },
    );

  curalate.filter('revenueSymbol',
        () => function(revenueFormat) {
          return getRevenueSymbolFromFormat(revenueFormat);
        },
    );

  curalate.filter('optionalNumber',
    ['$filter', $filter => function(val, fractionSize) {
      if (_.isUndefined(val) || _.isNaN(val) || val === -1) {
        return '--';
      }
      return $filter('number')(val, fractionSize);
    }],
    );

    // We assume that the number is in milliseconds
  const readableTimeImpl = function(val) {
    if (!_.isNumber(val)) {
      return val;
    }

    const totalTimeSeconds = val / 1000;
    const minutes = Math.floor(totalTimeSeconds / 60);
    const seconds = Math.floor(totalTimeSeconds % 60);
    const displayMinutes = minutes > 0 ? `${minutes}m ` : '';
    return `${displayMinutes}${seconds}s`;
  };

  curalate.filter('readableTime',
        () => readableTimeImpl,
    );
})();
